import {
  showErrorMsg,
  showRequestSubmitted,
  showSuccessMsg,
} from "../utils/toast";
import api from "./api";
import { StorageUtils } from "../utils";
import { APP_USER_SESSION } from "../constant/AppConstants";
import { stringifyValues } from "../utils/tableFunctions";
import { formatObject } from "../utils/appUtils";
import toast from "react-hot-toast";
import { Alert } from "@blueprintjs/core";
import { apiLogout } from "./auth.service";
import fileDownload from "js-file-download";
const userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

// --------------- API Calls for Accounts ----------------------- //
export async function setUserRole(setTrue) {
  const url = "/admins/account/get_roles/";
  const userSession = StorageUtils.getParsedValue(APP_USER_SESSION);
  await api
    .get(url)
    .then((res) => {
      if (res.status !== 200) {
          toast.custom(
          <Alert
            style={{ width: "auto" }}
            children={<p>{res.data?.detail || res.data?.toString()}</p>}
            isOpen
            onClose={() => {
              apiLogout();
              toast.dismiss();
            }}
          />,
          {
            duration: Infinity
          }
        );

        return;
      }

      userSession.role = res.data.permission;
      userSession.oxygen7_entity = res.data.oxygen7_entity;
      StorageUtils.setValue(APP_USER_SESSION, userSession);
      setTrue(true);
    })
}

export async function getAccountFilterConditions(setResponse, setLoaded) {
  const url = "/admins/account/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPendingAccountList({ setResponse, setLoaded, filter = {}, queryParams = null }) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/admins/pending_account/filter/${queryString}`;
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getHistoryAccountList({
  setResponse,
  setLoaded,
  filter,
  queryParams,
}) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/admins/pending_account/filter_history/${queryString}`;
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
      setLoaded && setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getHistoryAccountFilterConditions(
  setResponse,
  setLoaded
) {
  const url = "/admins/pending_account/filter_conditions/history/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getAccountDetails(id, setResponse, setLoaded) {
  const url = `/admins/account/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getAccountWithActions(id, setResponse, setLoaded) {
  const url = `/admins/pending_account/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded(true));
}

export async function getCreateAccOptions(setResponse, setLoaded) {
  const url = `/admins/account/static/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function createNewAccount(
  email,
  firstName,
  lastName,
  contactNumber,
  department,
  group,
  oxygen7_entity,
  salutation,
  cb
) {
  const url = `/admins/pending_account/request/`;
  const params = {
    action: "ADD",
    email: email?.trim()?.toLowerCase(),
    first_name: firstName,
    last_name: lastName,
    contact_number: contactNumber,
    department: department,
    group: group,
    oxygen7_entity: oxygen7_entity,
    salutation: salutation,
  }

  Log.info('Click button [Submit] - Create A New Account', params)
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showRequestSubmitted();
        cb?.();
      } else {
        showErrorMsg(res?.data?.detail);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function updateAccount(
  id,
  email,
  firstName,
  lastName,
  contactNumber,
  department,
  group,
  oxygen7_entity,
  salutation,
  setResponse,
  setLoaded
) {
  const url = `/admins/pending_account/request/`;
  const params = {
    pk: id,
    action: "UPDATE",
    email: email?.trim()?.toLowerCase(),
    first_name: firstName,
    last_name: lastName,
    contact_number: contactNumber,
    department: department,
    group: group,
    oxygen7_entity: oxygen7_entity,
    salutation: salutation,
  }
  Log.info('Click button [Submit] - Update account details', params)
  await api
    .post(url, {
      pk: id,
      action: "UPDATE",
      email: email?.trim()?.toLowerCase(),
      first_name: firstName,
      last_name: lastName,
      contact_number: contactNumber,
      department: department,
      group: group,
      oxygen7_entity: oxygen7_entity,
      salutation: salutation,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showRequestSubmitted();
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function removeAccount(id, reason, setResponse, setLoaded) {
  const url = `/admins/pending_account/request/`;
  const params = {
    pk: id,
    action: "REMOVE",
    action_message: reason,
  }
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data.detail);
      } else {
        showErrorMsg(res.data.detail);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function approvePendingAccount(id, setResponse, setLoaded, queryParams = null) {
  const url = `/admins/account/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "approve",
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingAccountList({ setResponse, setLoaded, queryParams });
      } else showErrorMsg(res.data.details);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function rejectPendingAccount(id, reason, setResponse, setLoaded, queryParams = null) {
  const url = `/admins/account/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "reject",
      reject_message: reason,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingAccountList({ setResponse, setLoaded, queryParams });
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

// --------------- API Calls for Groups ----------------------- //
export async function getGroupList(
  setResponse,
  setLoaded,
  { name, is_active, name_input } = "",
  queryParams = null
) {
  let url = "/admins/group/filter/";
  if (queryParams) {
    url += `?page=${queryParams.page}&page_size=${queryParams.page_size}`;
  }

  await api
    .post(url, {
      name: name,
      is_active: is_active,
      name_input
    })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, { name, is_active }, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getGroupFilterConditions(setResponse, setLoaded) {
  const url = "/admins/group/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPendingGroupList({ setResponse, setLoaded, filter = {}, queryParams = null }) {
  let url = "/admins/pending_group/filter/";
  if (queryParams) {
    url += `?page=${queryParams.page}&page_size=${queryParams.page_size}`;
  }

  await api
    .post(url, filter)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getHistoryGroupList({ setResponse, setLoaded, filter, queryParams = null }) {
  let url = "/admins/pending_group/filter_history/";
  if (queryParams) {
    url += `?page=${queryParams.page}&page_size=${queryParams.page_size}`;
  }
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getHistoryGroupFilterConditions(setResponse, setLoaded) {
  const url = "/admins/pending_group/filter_conditions/history/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getGroupDetails(id, setResponse, setLoaded) {
  const url = `/admins/group/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getGroupDetailsWithActions(id, setResponse, setLoaded) {
  const url = `/admins/pending_group/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getTaggedAccounts(id, setResponse) {
  const url = `/admins/group/details_tagged/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, { id }, error)
    });
}

export async function approvePendingGroup(id, setResponse, setLoaded, queryParams = null) {
  const url = `/admins/group/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "approve",
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingGroupList({ setResponse, setLoaded, queryParams });
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function rejectPendingGroup(id, comment, setResponse, setLoaded, queryParams = null) {
  const url = `/admins/group/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "reject",
      reject_message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingGroupList({ setResponse, setLoaded, queryParams });
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function removeGroup(id, reason, setResponse, setLoaded) {
  const url = `/admins/pending_group/request/`;
  const params = {
    pk: id,
    action: "REMOVE",
    action_message: reason,
  }
  Log.info(`Click button [Submit] - Delete Group Role by Id: ${id}`, params)
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data.details);
        setLoaded(false);
        getGroupList(setResponse, setLoaded);
      } else {
        showErrorMsg(res.data.detail);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function createNewGroup(values, cb) {
  const url = `/admins/pending_group/request/`;

  values = stringifyValues(values);
  const params = {
    action: "ADD",
    ...values,
  }
  Log.info('Click button [Submit] - Add new Group Role', params)
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showRequestSubmitted();
        cb?.();
        // window.location.reload();
      } else {
        showErrorMsg(res.data?.detail)
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function updateGroup(id, values) {
  values = stringifyValues(values);
  const url = `/admins/pending_group/request/`;
  const params = {
    pk: id,
    action: "UPDATE",
    ...values,
  }
  Log.info(`Click button [Submit] - Update Group Role by Id: ${id}`, values)
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showRequestSubmitted();
      } else {
        showErrorMsg(res.data?.detail)
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

// --------------- API Calls for MerchantUser ----------------------- //

export async function getCreateMerchantUserOptions(setResponse, setLoaded) {
  const url = `/merchant/merchant_user/static/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function MerchantUserActions(
  { action, params, pk, action_message },
  cb
) {
  const url = `/merchant/merchant_user/request/`;
  const payload = {
    ...params,
    action: action,
    pk: pk,
    action_message: action_message,
  }
  await api
    .post(url, payload)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showRequestSubmitted();
        cb?.();
      } else if (res.status === 401) {
        showErrorMsg(res?.data?.detail.toString());
        Log.error(url, payload, res)
      } else if (res.status === 404) {
        showErrorMsg(res?.data.toString());
        Log.error(url, payload, res)
      } else {
        showErrorMsg(res?.data?.detail.toString());
        Log.error(url, payload, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail.toString());
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data.toString());
      } else {
        showErrorMsg(error.message.toString());
      }
      Log.error(url, payload, error)
    });
}

export async function getMerchantUserFilterConditions(setResponse, setLoaded) {
  const url = "/merchant/merchant_user/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true))
}

export async function downloadActiveMerchantUserEmails() {
  const url = "/merchant/merchant_user/filter/";

  try {
    const response = await api.post(
      url,
      { download: true },
      { responseType: "blob" }
    );

    if (response?.status !== 200) {
      throw new Error("Failed to download active merchant emails");
    }

    const contentDisposition = response.headers?.["content-disposition"];
    const filenameMatch = contentDisposition?.match(/filename="?([^";]+)"?/i);
    const filename = filenameMatch?.[1] || "active_merchant_emails.xlsx";

    fileDownload(response.data, filename);
  } catch (error) {
    showErrorMsg(error.message || "Failed to download active merchant emails");
    Log.error(url, { download: true }, error);
    throw error;
  }
}

export async function getMerchantUserDetails(id, setResponse, setLoaded) {
  const url = `/merchant/merchant_user/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPendingMerchantUsers({ setResponse, setLoaded, filter = {}, queryParams = null }) {
  let url = `/merchant/pending_merchant_user/filter/`;
  if (queryParams) {
    url += `?page=${queryParams.page}&page_size=${queryParams.page_size}`;
  }

  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function PendingMerchantUserAction(
  id,
  action,
  setResponse,
  setLoaded,
  { reject_message } = "",
  queryParams = null
) {
  const url = `/merchant/pending_merchant_user/approver/`;
  const params = {
    pk: id,
    choice: action,
    reject_message: reject_message,
  }
  return await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingMerchantUsers({ setResponse, setLoaded, queryParams });
      } else {
        showErrorMsg(res.data);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function getMerchantUserHistory({
  setResponse,
  setLoaded,
  filter,
  queryParams = null
}) {
  let url = `/merchant/pending_merchant_user/filter_history/`;
  if (queryParams) {
    url += `?page=${queryParams.page}&page_size=${queryParams.page_size}`;
  }
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getMerchantUserWithActions(id, setResponse, setLoaded) {
  const url = `/merchant/pending_merchant_user/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

// --------------- API Calls for Business Entity ----------------------- //

export async function getBusinessEntity(setResponse, setLoaded, fParams) {
  const url = "/merchant/business_entity/filter/";
  await api
    .post(url, {
      ...fParams,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else {
        showErrorMsg(res.data?.toString());
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, fParams, error)
    })
    .finally(() => setLoaded?.(true))
}

export async function getEntityFilterConditions(setResponse, setLoaded) {
  const url = "/merchant/business_entity/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        const desiredOrder = ['SGP', 'MYS', 'THA', 'HKG', 'IND'];
        const sortedData = res.data.registered_country.sort((a, b) => {
        const aIndex = desiredOrder.indexOf(a.registered_country__registered_country);
        const bIndex = desiredOrder.indexOf(b.registered_country__registered_country);
        return aIndex - bIndex;
      });
      setResponse({
        ...res.data,
        registered_country: sortedData
      });
      } else {
        showErrorMsg(res.data?.toString());
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => {
      setLoaded(true);
    });
}

export async function getBusinessEntityDetails(id, setResponse, setLoaded) {
  const url = `/merchant/business_entity/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}
export async function getPendingEntityDetails(id, setResponse, setLoaded) {
  const url = `/merchant/pending_business_entity/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getTaggedMerchants(id, setResponse, filter) {
  const url = `/merchant/business_entity/details_tagged/${id}/`;
  await api
    .get(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getCreateEntityOptions(setResponse, setLoaded) {
  const url = `/merchant/business_entity/static/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export function getPendingBusinessEntity(
  setResponse,
  setLoaded,
  { business_name, status, registered_country, is_active, page, page_size } = {}
) {
  const queryString = page && page_size ? `?${new URLSearchParams({ page, page_size }).toString()}` : "";
  const url = `/merchant/pending_business_entity/filter/${queryString}`;
  api
    .post(url, {
      business_name: business_name,
      status: status,
      registered_country: registered_country,
      is_active: is_active,
    })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function businessEntityAction(
  action,
  {
    address_1,
    address_2,
    address_3,
    business_name,
    contact_email,
    contact_name,
    contact_number,
    registered_country,
    short_name,
    uen,
    postal_code,
    address_country,
    gdrive_link,
    selectedId,
    action_message,
    reject_message,
    merchant_payout,
    bank_accounts,
    last_kyc_review,
    next_kyc_review,
    risk_level
  } = "",
  cb
) {
  const url = `/merchant/pending_business_entity/request/`;
  const params = {
    action: action,
    address_1: address_1,
    address_2: address_2,
    address_3: address_3,
    business_name: business_name,
    contact_email: contact_email,
    contact_name: contact_name,
    contact_number: contact_number,
    registered_country: registered_country,
    short_name: short_name,
    uen: uen,
    postal_code,
    address_country,
    gdrive_link,
    pk: selectedId,
    action_message: action_message,
    reject_message: reject_message,
    merchant_id_with_source: merchant_payout?.map(item => `${item?.id}_${item?.source}`),
    bank_accounts: bank_accounts?.map(item => `${item?.id}`),
    last_kyc_review,
    next_kyc_review,
    risk_level
  };
  return await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        cb?.();
      } else if (res.status === 404) {
        showErrorMsg(res?.data.toString());
        Log.error(url, params, res)
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error);
    });
}

export async function getActiveBusinessEntity(setResponse, setLoaded) {
  const url = "/merchant/merchant/dropdown/";
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        const desiredOrder = ['SGP', 'MYS', 'THA', 'HKG', 'IND'];
        const sortedData = res?.data?.registered_country?.sort((a, b) => {
          const aIndex = desiredOrder.indexOf(a.registered_country);
          const bIndex = desiredOrder.indexOf(b.registered_country);
          return aIndex - bIndex;
        });
        setResponse({
          ...res?.data,
          registered_country: sortedData
        });
      } else {
        showErrorMsg();
      }
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded?.(true));
}

// --------------- API Calls for Exchange Rates ----------------------- //
export async function getExchangeRateFilterConditions(setResponse, setLoaded) {
  const url = "/payout/exchange_rate/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getExchangeRateDetails(id, setResponse, setLoaded) {
  const url = `/payout/exchange_rate/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function createExchangeRate(data, onSuccess) {
  const url = "/payout/exchange_rate/";
  await api
    .post(url, data)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg("Exchange rate created successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to create exchange rate");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to create exchange rate");
      }
    });
}

export async function updateExchangeRate(id, data, onSuccess) {
  const url = `/payout/exchange_rate/${id}/`;
  await api
    .put(url, data)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg("Exchange rate updated successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to update exchange rate");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to update exchange rate");
      }
    });
}

export async function getLastMonthRate(toCurrency, rateDate, setResponse, setLoaded) {
  let url = `/payout/exchange_rate/last_month_rate/?to_currency=${toCurrency}`;
  if (rateDate) {
    url += `&rate_date=${rateDate}`;
  }
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else {
        // Don't show error for this, just return null values
        setResponse({ rate: null, spread: null });
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getNoPayoutDayFilter(params, setResponse, setLoaded) {
  const { page = 1, page_size = 50, year, day } = params;
  const queryString = new URLSearchParams({ page, page_size }).toString();
  const url = `/payout/no_payout_day/filter/?${queryString}`;
  await api
    .post(url, { year, day })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getNoPayoutDayDetails(id, setResponse, setLoaded) {
  const url = `/payout/no_payout_day/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function createNoPayoutDay(data, onSuccess) {
  const url = "/payout/no_payout_day/";
  await api
    .post(url, data)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg("No payout day created successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to create no payout day");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to create no payout day");
      }
    });
}

export async function updateNoPayoutDay(id, data, onSuccess) {
  const url = `/payout/no_payout_day/${id}/`;
  await api
    .put(url, data)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg("No payout day updated successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to update no payout day");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to update no payout day");
      }
    });
}

export async function approveNoPayoutDay(id, onSuccess) {
  const url = `/payout/no_payout_day/${id}/approve/`;
  await api
    .post(url)
    .then((res) => {
      if (res.status === 200) {
        showSuccessMsg("No payout day approved successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to approve no payout day");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to approve no payout day");
      }
    });
}

export async function rejectNoPayoutDay(id, onSuccess) {
  const url = `/payout/no_payout_day/${id}/reject/`;
  await api
    .post(url)
    .then((res) => {
      if (res.status === 200) {
        showSuccessMsg("No payout day rejected successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to reject no payout day");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to reject no payout day");
      }
    });
}

export async function deleteNoPayoutDay(id, onSuccess) {
  const url = `/payout/no_payout_day/${id}/delete/`;
  await api
    .post(url)
    .then((res) => {
      if (res.status === 200) {
        showSuccessMsg("No payout day deleted successfully");
        onSuccess && onSuccess();
      } else {
        showErrorMsg(res.data?.detail || "Failed to delete no payout day");
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 400) {
        showErrorMsg(error.response?.data?.detail || "Invalid data");
      } else {
        showErrorMsg(error.message || "Failed to delete no payout day");
      }
    });
}

export async function getCountryList(setResponse) {
  const url = "/merchant/merchant/dropdown/";

  api.get(url).then((res) => {
    const desiredOrder = ['SGP', 'MYS', 'THA'];

    const sortedData = [...res.data.registered_country].sort((a, b) => {
      const aIndex = desiredOrder.indexOf(a.registered_country);
      const bIndex = desiredOrder.indexOf(b.registered_country);

      const aPriority = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
      const bPriority = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;

      if (aPriority !== bPriority) {
        return aPriority - bPriority;
      }

      return a.registered_country.localeCompare(b.registered_country);
    });

    setResponse(sortedData);
  });
}

export async function getModeList(setResponse) {
  const url = "/merchant/terminal/static/";
  api
    .get(url)
    .then((res) => setResponse(res.data))
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function PendingEntityAction(
  id,
  action,
  setResponse,
  setLoaded,
  { reject_message } = ""
) {
  const url = `/merchant/business_entity/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message: reject_message,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingBusinessEntity(setResponse, setLoaded);
      } else {
        showErrorMsg(res.data);
        Log.error(url, {
          pk: id,
          choice: action,
          reject_message: reject_message,
        },
        res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        choice: action,
        reject_message: reject_message,
      },
      error)
    });
}

export function getHistoryEntityList({ setResponse, setLoaded, filter, page, page_size }) {
  const queryString = page && page_size ? `?${new URLSearchParams({ page, page_size }).toString()}` : "";
  const url = `/merchant/pending_business_entity/filter_history/${queryString}`;
  api
    .post(url, { ...filter })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export function getHistoryEntityFilterConditions(setResponse, setLoaded) {
  const url = "/merchant/pending_business_entity/filter_conditions/history/";
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

// --------------- API Calls for Merchant ----------------------- //
export async function getMerchant(setResponse, setLoaded, fParams) {
  const url = "/merchant/merchant/filter/";
  await api
    .post(url, { ...fParams })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, fParams, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getMerchantFilterConditions(setResponse, setLoaded) {
  const url = "/merchant/merchant/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      const desiredOrder = ['SGP', 'MYS', 'THA', 'HKG', 'IND'];
      const sortedData = res?.data?.registered_country?.sort((a, b) => {
        const aIndex = desiredOrder.indexOf(a.registered_country__registered_country);
        const bIndex = desiredOrder.indexOf(b.registered_country__registered_country);
        return aIndex - bIndex;
      });
      setResponse({
        ...res?.data,
        registered_country: sortedData
      });
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => {
      setLoaded(true);
    });
}

export function getMerchantDetails(id, setResponse, setLoaded) {
  const url = `/merchant/merchant/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getMerchantWithActions(id, setResponse, setLoaded) {
  const url = `/merchant/pending_merchant/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getTaggedTerminals(id, setResponse) {
  const url = `/merchant/merchant/details_tagged/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export function merchantAction(
  action,
  {
    data,
    cb
  },
  setResponse,
  setLoaded,
  reason = ""
) {
  const url = `/merchant/pending_merchant/request/`;
  const params = {
    action: action,
    ...data,
    action_message: reason,
  }
  return api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
        cb?.();
        if (setResponse) {
          getPendingMerchant(setResponse, setLoaded);
        }
      } else {
        showErrorMsg(res?.data?.detail);
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.response?.data?.detail ?? error.message);
      }
      Log.error(url, params, error)
    });
}

export async function getPendingMerchant({
  setResponse,
  setLoaded,
  filter,
  queryParams
}) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/merchant/pending_merchant/filter/${queryString}`;
  api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
      setLoaded?.(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function PendingMerchantAction(
  id,
  action,
  setMerchantList,
  setLoaded,
  comment = ""
) {
  const url = `/merchant/merchant/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingMerchant({ setResponse: setMerchantList, setLoaded });
      } else showErrorMsg(res.data?.toString());
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function SuspendMerchant(pk, action, comment) {
  const url = `/merchant/merchant/suspend_route/`;
  return await api
    .post(url, {
      pk: pk,
      action: action,
      comment: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
      } else showErrorMsg(res.data.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export function getHistoryMerchant({ setResponse, setLoaded, filter, queryParams }) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/merchant/pending_merchant/filter_history/${queryString}`;
  api
    .post(url, { ...filter })
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg(res.data?.toString());
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export function getHistoryMerchantFilterConditions(setResponse) {
  const url = "/merchant/pending_merchant/filter_conditions/history/";
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

// export function getChargebackTotalAmount(setAmount) {
//   const url = "/dashboard/recon/mismatch/admin/chargeback/total_amount/";
//   api.get(url).then((response) => {
//     setAmount(response.data);
//   });
// }
// --------------- API Calls for Terminal ----------------------- //

export async function getTerminalFilterConditions(setResponse, setLoaded) {
  const url = "/merchant/terminal/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getPendingTerminalFilterConditions(status, setResponse, setLoaded) {
  const url = `/merchant/pending_terminal/filter_conditions/${status}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getPendingTerminalList({ setResponse, setLoaded, filter, queryParams }) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/merchant/pending_terminal/filter/${queryString}`;
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
      setLoaded?.(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getHistoryTerminalList({ setResponse, setLoaded, filter, queryParams }) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/merchant/pending_terminal/filter_history/${queryString}`;
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getTerminalDetails(id, setResponse, setLoaded, cbErr) {
  const url = `/merchant/terminal/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg();
        cbErr?.();
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getTerminalDetailsWithActions(
  id,
  setResponse,
  setLoaded
) {
  const url = `/merchant/pending_terminal/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

const deepTrim = (v) => {
  if (typeof v === "string") return v.trim();
  if (Array.isArray(v)) return v.map(deepTrim);
  if (v && typeof v === "object") {
    return Object.fromEntries(
      Object.entries(v).map(([k, val]) => [k, deepTrim(val)])
    );
  }
  return v;
};

export async function TerminalActions(
  action,
  { terminal_id, merchant, mode, operator_id, operator_password, registered_country, payment, pk } = "",
  cb
) {
  const url = `/merchant/pending_terminal/request/`;
  const params = {
    action: action,
    terminal_id: terminal_id,
    merchant: merchant,
    mode: mode,
    operator_id: typeof operator_id === "string" ? operator_id.trim() : operator_id,
    operator_password,
    registered_country: registered_country,
    payment: JSON.stringify(deepTrim(payment)),
    pk: pk,
  };
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        cb?.();
      } else {
        showErrorMsg(res?.data?.detail)
        Log.error(url, params, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    });
}

export async function getTerminalOptions(setResponse, setLoaded) {
  const url = "/payment/payment_host/payment_mapping_relation/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .finally(() => setLoaded(true))
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getPaymentBrandOptions(
  setResponse,
  setLoaded,
  payment_method
) {
  const url = "/payment/payment_brand/dropdown/";
  await api
    .post(url, {
      payment_method,
    })
    .then((res) => {
      const payload = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.name)
          ? res.data.name
          : Array.isArray(res?.data?.results)
            ? res.data.results
            : [];
      setResponse(payload);
    })
    .catch((error) => {
      Log.error(url, { payment_method }, error);
    })
    .finally(() => setLoaded?.(true));
}

export async function getPaymentHostOptions(
  setResponse,
  setLoaded,
  payment_brand
) {
  const url = "/payment/payment_host/dropdown/";
  await api
    .post(url, {
      payment_brand,
    })
    .then((res) => {
      const payload = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.name)
          ? res.data.name
          : Array.isArray(res?.data?.results)
            ? res.data.results
            : [];
      setResponse(payload);
    })
    .catch((error) => {
      Log.error(url, { payment_brand }, error);
    })
    .finally(() => setLoaded?.(true));
}

export async function getPaymentHostWithCurrencies(setResponse, setLoaded) {
  const url = "/payment/payment_host/with_currencies/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function approvePendingTerminal(id, setResponse, setLoaded) {
  const url = `/merchant/terminal/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "approve",
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingTerminalList({ setResponse, setLoaded });
      } else {
        showErrorMsg(res.data);
        Log.error(url, {
          pk: id,
          choice: "approve",
        },
        res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        choice: "approve",
      },
      error)
    });
}

export async function rejectPendingTerminal(
  id,
  comment,
  setResponse,
  setLoaded
) {
  const url = `/merchant/terminal/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: "reject",
      message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingTerminalList({ setResponse, setLoaded });
      } else {
        showErrorMsg(res.data?.detail)
        Log.error(url, {
          pk: id,
          choice: "reject",
          message: comment,
        },
        res)
      };
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        choice: "reject",
        reject_message: comment,
      },
      error)
    });
}

export async function removeTerminal(
  id,
  action_message,
  setResponse,
  setLoaded
) {
  const url = `/merchant/pending_terminal/request/`;
  await api
    .post(url, {
      pk: id,
      action: "REMOVE",
      action_message: action_message,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data.details);
      } else {
        showErrorMsg(res.data.detail);
        Log.error(url, {
          pk: id,
          action: "REMOVE",
          action_message: action_message,
        },
        res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        action: "REMOVE",
        action_message: action_message,
      },
      error)
    });
}

// --------------- API Calls for Merchant Payout Info ----------------------- //

export async function getPayoutInfo(setResponse, setLoaded, fParams = null) {
  const url = "/merchant/merchant_payout_info/filter/";
  await api
    .post(url, { ...fParams })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, fParams, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getPayoutFilterConditions(setResponse, setLoaded) {
  const url = `/merchant/merchant_payout_info/filter_conditions/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPayoutDetails(id, setResponse, setLoaded) {
  const url = `/merchant/merchant_payout_info/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPayoutEventDetails(id, setResponse, setLoaded) {
  const url = `/merchant/merchant_payout_info_event/details/${id}/`;
  await api
    .get(url)
    .then(({ data }) => {
      let res = {
        ...data,
        bank_details: {
          account_number: data.account_number,
          bank: data.bank,
          bank_address: data.bank_address,
          bank_mid: data.bank_mid,
          bank_transfer_fee: data.bank_transfer_fee,
          beneficiary_address: data.beneficiary_address,
          beneficiary_bank_code: data.beneficiary_bank_code,
          beneficiary_branch_code: data.beneficiary_branch_code,
          beneficiary_name: data.beneficiary_name,
          iban: data.iban,
          intermediary_bank: data.intermediary_bank,
          intermediary_bank_code: data.intermediary_bank_code,
          intermediary_name: data.intermediary_name,
        },
      };
      setResponse(res);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPaymentHostRelation(setResponse, setLoaded) {
  const url = `/merchant/merchant_payout_info/merchant_paymenthost_relation/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded(true));
}

export async function getPayoutStatic(setResponse) {
  const url = `/merchant/merchant_payout_info/static/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg());
}

export async function payoutAction(
  action,
  setResponse,
  setLoaded = null,
  values = "",
  pk = null,
  onClose = false
) {
  const url = `/merchant/merchant_payout_info/action/`;
  return await api
    .post(url, {
      action: action,
      pk: pk,
      ...values,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
        if (onClose) {
          onClose();
        }
        if (setResponse) {
          getPayoutInfo(setResponse, setLoaded);
        }
      } else {
        showErrorMsg(res.data);
      }
    })
    .catch((err) => showErrorMsg(err));
}

export async function getPayoutHistory({ setResponse, setLoaded, filter }) {
  const url = "/merchant/merchant_payout_info_event/filter/";
  await api
    .post(url, { ...filter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getPayoutHistoryFilterConditions(setResponse, setLoaded) {
  const url = `/merchant/merchant_payout_info_event/filter_conditions/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getNextPage({ url, filter }) {
  const res = await api.post(url, {
    ...filter,
  });
  return res.data;
}

export async function getFilterConditions(url = '', setResponse, setLoaded) {
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .catch(() => setLoaded(true))
}

export async function virtualAccountAction(
  payload = {},
  setResponse,
  setLoaded,
  filter = {},
  params = {}
) {
  const url = '/virtualaccount/pending_virtualaccount/request/';
  await api
    .post(url, {
      ...payload
    })
    .then((res) => {
      const message = res?.data?.detail;
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
        if (setResponse) {
          setLoaded(false);
          getVirtualAccountList(setResponse, setLoaded, filter, params);
        }
      } else {
        showErrorMsg(message);
        Log.error(url, payload, res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, payload, error)
    });
}

export async function getVirtualAccountList(
  setList,
  setLoaded,
  filter = {},
  params = {},
  cb
) {
  const queryParams = new URLSearchParams(params).toString();
  const url = `/virtualaccount/virtualaccount/filter/?${queryParams}`;
  api.post(url, {
    ...filter
  })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        setList(response.data);
        cb?.();
      } else showErrorMsg(response?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getVirtualAccountDetails(id, setResponse, setLoaded) {
  const url = `/virtualaccount/virtualaccount/${id}/`;
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPendingVirtualAccount(
  setResponse,
  setLoaded,
  filter = {},
  params = {},
  cb
) {
  const queryParams = new URLSearchParams(params).toString();
  const url = `/virtualaccount/pending_virtualaccount/filter/?${queryParams}`;
  api
    .post(url, {
      ...filter
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
        cb?.();
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export function PendingVirtualAccountAction(
  name = '',
  payload = {},
  setResponse,
  setLoaded,
  filter = {},
  params = {}
) {
  const url = `/virtualaccount/virtualaccount/${name}/`;
  api
    .post(url, {
      ...payload
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
        setLoaded(false);
        getPendingVirtualAccount(setResponse, setLoaded, filter, params);
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getHistoryVirtualAccountList(
  setList,
  setLoaded,
  filter = {},
  params = {},
  cb
) {
  const queryParams = new URLSearchParams(params).toString();
  const url = `/virtualaccount/pending_virtualaccount/filter_history/?${queryParams}`;

  api.post(url, {
    ...filter
  })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        setList(response.data);
        cb?.();
      } else showErrorMsg(response?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function generateAccountNumber(payload = {}, setResponse, setLoaded) {
  const url = '/virtualaccount/virtualaccount/generate-account-number/';
  await api
    .post(url, { ...payload })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data?.account_number);
        setLoaded(true)
      } else showErrorMsg(res?.data?.detail);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function sendDataWithPost(url, payload = {}, setList, setLoaded, cb, cbError, headers = {}, showSuccess = false) {
  try {
    const response = await api.post(url, payload, { headers });
    if (response?.status === 200 || response?.status === 201) {
      setList?.(response.data);
      cb?.(response);
      if (showSuccess) {
        showSuccessMsg(response.data?.detail);
      }
      return response;
    } else {
      const errorData = response?.data?.detail || response?.data;
      const errorMsg = typeof errorData === 'string' ? errorData : JSON.stringify(errorData);
      showErrorMsg(errorMsg);
      cbError?.();
      Log.error(url, payload, response);
      return response;
    }
  } catch (error) {
    if (error.response?.status === 401) {
      showErrorMsg(error.response?.data?.detail);
    } else if (error.response?.status === 404) {
      showErrorMsg(error.response?.data);
    } else {
      showErrorMsg(error.message);
    }
    cbError?.();
    Log.error(url, payload, error);
    throw error;
  } finally {
    setLoaded?.(true);
  }
}

export async function sendDataWithGet(url, setList, setLoaded, cb, cbError) {
  try {
    await api.get(url).then((response) => {
      if (response.status === 200 || response.status === 201) {
        setList?.(response.data);
        cb?.();
      } else {
        showErrorMsg(response?.data?.detail);
        cbError?.()
      }
    });
  } catch (error) {
    if (error.response?.status === 401) {
      showErrorMsg(error.response?.data?.detail);
    } else if (error.response?.status === 404) {
      showErrorMsg(error.response?.data);
    } else {
      showErrorMsg(error.message);
    }
    cbError?.()
  }
  finally {
    setLoaded?.(true);
  }
}

export async function sendDataWithPut(url, payload = {}, setLoaded, cb, cbError, headers = {}) {
  try {
    await api.put(url, payload, { headers }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        cb?.(response)
      } else {
        showErrorMsg(response?.data?.detail.toString())
        cbError?.()
        Log.error(url, payload, response)
      };
    });
  } catch (error) {
    if (error.response?.status === 401) {
      showErrorMsg(error.response?.data?.detail);
    } else if (error.response?.status === 404) {
      showErrorMsg(error.response?.data);
    } else {
      showErrorMsg(error.message);
    }
    cbError?.()
    Log.error(url, payload, error)
  } finally {
    setLoaded?.(true);
  }
}

export async function sendDataWithDelete(url, setLoaded, cb, cbError) {
  try {
    await api.delete(url).then((response) => {
      if (response.status === 200 || response.status === 201 || response.status === 204) {
        cb?.(response);
      } else {
        showErrorMsg(response?.data?.detail);
        cbError?.()
      }
    });
  } catch (error) {
    if (error.response?.status === 401) {
      showErrorMsg(error.response?.data?.detail);
    } else if (error.response?.status === 404) {
      showErrorMsg(error.response?.data);
    } else {
      showErrorMsg(error.message);
    }
    cbError?.()
  }
  finally {
    setLoaded?.(true);
  }
}

export const Log = {
  info: (message = '', params) => {
    const formattedString = formatObject(params)
    const msg = `[Info] - ${message} - params: {${formattedString}}`
    writeLog(msg)
  },
  error: (url, params, error = "") => {
    const message = error?.response?.data?.detail || error?.response?.data || error?.message || error?.data?.detail ||  error?.data?.details ||error
    const formattedString = formatObject(params)
    const msg = `[Error] - System Response - Endpoint: ${url} - params: {${formattedString}} - message: ${message}`
    writeLog(msg)
  }
}

export async function writeLog(message = "") {
  const query = {
    message: message.toLowerCase(),
    username: userSession?.user?.email,
    service_scope: "AdminPortal"
  };

  await api.post("/auditlog/create-log/", query);
};


export function getPendingBankAccount(
  setResponse,
  setLoaded,
  payload = {}
) {
  const { page, page_size, ...rest } = payload;
  const queryString = page && page_size ? `?${new URLSearchParams({ page, page_size }).toString()}` : "";
  const url = `/bank_account/bank_account_pending/filter/${queryString}`;
  api
    .post(url, {
      ...rest
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getPendingBankAccountDetails(id, setResponse, setLoaded) {
  const url = `/bank_account/bank_account_pending/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function BankAccountApprover(
  id,
  action,
  setResponse,
  setLoaded,
  { reject_message } = {}
) {
  const url = `/bank_account/bank_account/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingBankAccount(setResponse, setLoaded);
      } else {
        showErrorMsg(res.data);
        Log.error(url, {
          pk: id,
          choice: action,
          reject_message
        },
        res)
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        choice: action,
        reject_message
      },
      error)
    });
}

export async function PendingBankAccountAction(
  action,
  payload = {},
  cb
) {
  const url = `/bank_account/bank_account_pending/request/`;
  const params = {
    action,
    ...payload
  };
  return await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        cb?.();
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, params, error);
    });
}

export function getPendingMerchantPayoutInfo(
  setResponse,
  setLoaded,
  { queryParams, payload } = {}
) {
  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";
  const url = `/bank_account/merchant_payout_info_pending/filter/${queryString}`;
  api
    .post(url, {
      ...payload,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getPendingMerchantPayoutInfoDetails(id, setResponse, setLoaded) {
  const url = `/bank_account/merchant_payout_info_pending/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function MerchantPayoutApprover(
  id,
  action,
  { reject_message, cb } = {}
) {
  const url = `/bank_account/merchant_payout_info/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        cb?.();
        return true;
      } else {
        showErrorMsg(res.data);
        Log.error(url, {
          pk: id,
          choice: action,
          reject_message
        },
        res)
        return false;
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
      Log.error(url, {
        pk: id,
        choice: action,
        reject_message
      },
      error)
    });
}

export async function getMIDList(setResponse, setLoaded) {
  const url = "/merchant/merchant/get_merchant/";
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data?.detail);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

export async function getTerminalsByMID(id, setResponse, setLoaded) {
  const url = `/merchant/terminal/mid/${id}/`;
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data?.detail);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

// --------------- API Calls for Bank Account Details ----------------------- //

export async function getBankAccountDetails(id, setResponse, setLoaded) {
  const url = `/bank_account/bank_account/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data?.detail);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded?.(true));
}

// --------------- API Calls for Merchant Payout Details ----------------------- //

export async function getMerchantPayoutDetails(merchantId, setResponse, setLoaded) {
  const url = `/payout/ingestor_merchant/merchant_payout/${merchantId}`;
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data?.detail);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })

    .finally(() => setLoaded(true));
}

// Onboarding: real APIs
export async function getOnboardingDropdown() {
  const url = "/merchant/onboarding/dropdown/";
  return api.get(url);
}

export async function getOnboardingList(payload = {}, page = 1, page_size = 50) {
  // Calls backend filter action to retrieve onboarding list with filters
  const url = `/merchant/onboarding/filter/?page=${page}&page_size=${page_size}`;
  return api.post(url, payload);
}

export async function checkUENExists(uen) {
  try {
    const response = await api.get(`/merchant/onboarding/check-uen/`, {
      params: {
        uen: uen
      }
    });
    return response.data.exists;
  } catch (error) {
    console.error('Error checking UEN:', error);
    return false;
  }
}

// Returns the current logged-in user's oxygen7_entity as { id, label } or null
export async function getCurrentUserEntity() {
  try {
    const gw3User = JSON.parse(localStorage.getItem("gw3_user"));
    const refreshToken = gw3User?.refresh;
    if (!refreshToken) return null;
    const payload = JSON.parse(atob(refreshToken.split('.')[1]));
    const userId = payload?.user_id;
    if (!userId) return null;
    const response = await api.get(`/admins/account/${userId}/`);
    const entity = response.data?.oxygen7_entity;
    if (!entity) return null;
    return { id: entity.id, label: entity.entity };
  } catch {
    return null;
  }
}

// Onboarding step submission functions
export async function submitOnboardingStep(url,dataToSend) {
  try {
    const response = await api.post(url, dataToSend);
    if (response?.status === 200 || response?.status === 201) {
      const msg = typeof response?.data?.detail === 'string' ? response.data.detail : "Saved successfully.";
      showSuccessMsg(msg);
      return response;
    } else {
      const errMsg = typeof response?.data?.detail === 'string' ? response.data.detail : typeof response?.data === 'string' ? response.data : "An error occurred."
      showErrorMsg(errMsg);
      return response;
    }
  } catch (error) {
    const errData = error.response?.data;
    const detail = (typeof errData === 'string' ? errData : errData?.detail) || error.message;
    showErrorMsg(detail);
    throw error; // Re-throw to let caller handle
  }
}

export async function deleteOnboardingApplication(id) {
  try {
    const response = await api.delete(`/merchant/onboarding/${id}/delete-onboarding-application/`);
    if (response?.status === 200 || response?.status === 204) {
      showSuccessMsg(response?.data?.detail?.toString() || "Onboarding application deleted successfully");
      return response;
    } else {
      showErrorMsg(response?.data?.detail?.toString() || "Failed to delete onboarding application");
      return response;
    }
  } catch (error) {
    if (error.response?.status === 401) {
      showErrorMsg(error.response?.data?.detail);
    } else if (error.response?.status === 404) {
      showErrorMsg(error.response?.data);
    } else {
      showErrorMsg(error.message);
    }
    throw error;
  }
}
